import { mapGetters, mapActions } from 'vuex'
import { currencyUtil } from '@/util'

import { ExpansionPanel, TotalAmount } from '@/components/items'

import ClientSearch from '@/components/layouts/ClientSearchArea/ClientSearchAreaSale'
import ClientInfo from '@/components/layouts/ClientInfo/Sales/ClientInfo'
import ProductSearch from '@/components/layouts/ProductSearchArea/ProductSearchAreaSale'
import ProductInfo from '@/components/layouts/ProductInfo/Sales/ProductInfo'

import RegisterDialog from '@/components/layouts/Dialogs/MultipleArea/SalesInfoDialog/SalesRegisterDialog'

import DialogAlertError from '@/components/layouts/Dialogs/DialogAlert/DialogAlertError'

export default {
  name: 'Customers',

  components: {
    ExpansionPanel,

    ClientSearch,
    ClientInfo,
    ProductSearch,
    ProductInfo,

    TotalAmount,
    RegisterDialog,

    DialogAlertError
  },
  data: () => {
    return {
      pageTitle: 'sale.sale_order-edit',

      pageType: {
        en: 'sale',
        ja: '注文'
      },

      dialog: {
        dialog: false
      },

      registerData: {
        client: {},
        product: {
          isHistory: false,
          data: []
        },
        totalList: {
          taxFree: 0,
          tax10: {
            totalAmount: 0,
            tax: 0
          },
          tax8: {
            totalAmount: 0,
            tax: 0
          },
          discount: 0,
          shipping: 0,
          totalAmount: 0,

          unitName: ''
        }
      },

      clientAreaInfo: {
        isOpen: true,
        isSelect: false,
        selectInfo: {}
      },
      selectCurrency: { currencyId: null, name: '', unitName: '' },
      history: {
        productMoves: []
      },

      productSearchInfo: {
        keyword: '',
        category: ''
      },

      errMessage: '',
      errDialog: false
    }
  },
  async created() {
    if (!this.$route.params.selectItems) {
      alert(this.$t('common.common_unexpected-error'))
    }

    await this.getCountryListFromApi()

    this.changeClient('history', 'customerId', this.$route.params.selectItems)
    this.setCurrency(this.getCurrencyJpFromState().value)
  },
  methods: {
    ...mapGetters('Common', ['getCurrencyJpFromState']),
    ...mapActions('Common', ['getCountryListFromApi']),

    opnePanel(...args) {
      const [index] = args
      this.clientAreaInfo.isOpen = index.length > 0
    },

    changeClient(...args) {
      const [type, clientId, clientInfo] = args

      const isExist = clientId in clientInfo
      this.clientAreaInfo = {
        isOpen: isExist,
        isSelect: isExist,
        selectInfo: clientInfo
      }

      const isHistory = type === 'history'
      this.history.productMoves = isHistory ? clientInfo.productMoves : []
    },
    changeClientInfo(...args) {
      const [clientInfo] = args
      this.registerData.client = clientInfo

      this.setCurrency(clientInfo[this.pageType.en + 'Info'].currency.value)

      this.updateRegisterDataProductCurrencyId()
    },
    setCurrency(currencyId) {
      const currency = currencyUtil.findCurrencyNameById(currencyId)
      const selectCurrency = currency
        ? currency
        : { currencyId: null, name: '', unitName: '' }

      this.selectCurrency = selectCurrency
      this.registerData.totalList.unitName = selectCurrency.unitName
    },

    inputKeyword(...args) {
      const [keyword] = args
      this.productSearchInfo.keyword = keyword
    },
    selectCategory(...args) {
      const [categoryId] = args
      this.productSearchInfo.category = categoryId
    },

    changeProductInfo(...args) {
      const [isHistory, productInfo] = args

      const clientInfo = this.clientAreaInfo.selectInfo

      const totalList = this.registerData.totalList
      if (isHistory) {
        totalList.tax10.tax = clientInfo.consumptionTax10
        totalList.tax8.tax = clientInfo.consumptionTax8
        totalList.discount = clientInfo.discount
        totalList.shipping = clientInfo.comission
      }
      // totalList.tax10.tax = isHistory ? clientInfo.consumptionTax10 : 0
      // totalList.tax8.tax = isHistory ? clientInfo.consumptionTax8 : 0
      // totalList.discount = isHistory ? clientInfo.discount : 0
      // totalList.shipping = isHistory ? clientInfo.comission : 0
      this.registerData.product = {
        isHistory: isHistory,
        data: productInfo
          .filter((ele) => {
            return (
              ele.amount > 0 ||
              (ele.amount === 0 &&
                ele.price == 0 &&
                ele.count !== null &&
                ele.count > 0)
            )
          })
          .map((ele) => {
            ele.currencyId = this.selectCurrency.currencyId
            ele.disabledFlg = ele.invalid
            return ele
          })
      }
    },
    updateRegisterDataProductCurrencyId() {
      const productData = this.registerData.product.data
      if (!productData.length) return

      this.registerData.product.data = productData.map((ele) => {
        ele.currencyId = this.selectCurrency.currencyId
        return ele
      })
    },

    register() {
      // 登録情報に不備がないかチェック
      if (this.isInvalidCount) {
        alert(this.$t('sale.sale_invalid-count'))
        return
      }

      if (!this.clientAreaInfo.isSelect) {
        alert(this.$t('sale.sale_select-customer'))
        // this.errMessage = '顧客を選択してください'
        // this.errDialog = true
        return
      }
      if (!this.hasProducts || this.isAllDisabledProduct) {
        alert(this.$t('product.product_select-product'))
        // this.errMessage = '商品を選択してください'
        // this.errDialog = true
        return
      }
      this.dialog.dialog = true
    }
  },
  computed: {
    hasProducts() {
      return this.registerData.product.data.length > 0
    },
    isAllDisabledProduct() {
      return this.registerData.product.data.every(
        (product) => product.disabledFlg
      )
    },
    isInvalidCount() {
      return this.registerData.product.data.find(
        (product) => !product.count && !product.invalid
      )
    }
  },
  watch: {}
}
